// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as PublicIndexRouteImport } from './routes/_public/index'
import { Route as ProtectedExampleProtectedRouteRouteImport } from './routes/_protected/example-protected-route'
import { Route as AuthSignUpRouteImport } from './routes/_auth/sign-up'
import { Route as AuthSignOutRouteImport } from './routes/_auth/sign-out'
import { Route as AuthSignInRouteImport } from './routes/_auth/sign-in'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth/reset-password'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthCallbackRouteImport } from './routes/_auth/callback'
import { Route as PublicAppIndexRouteImport } from './routes/_public/app/index'
import { Route as PublicAppHelpIndexRouteImport } from './routes/_public/app/help/index'
import { Route as PublicAppHelpWindowsPhoneLinkRouteImport } from './routes/_public/app/help/windows-phone-link'
import { Route as PublicAppHelpPrivacySecurityRouteImport } from './routes/_public/app/help/privacy-security'
import { Route as PublicAppHelpImportIphoneRouteImport } from './routes/_public/app/help/import-iphone'
import { Route as PublicAppHelpImportIpadRouteImport } from './routes/_public/app/help/import-ipad'
import { Route as PublicAppHelpImportAndroidRouteImport } from './routes/_public/app/help/import-android'
import { Route as PublicAppHelpFaqRouteImport } from './routes/_public/app/help/faq'

const PublicRoute = PublicRouteImport.update({
            id: '/_public',getParentRoute: () => rootRouteImport
          })
const ProtectedRoute = ProtectedRouteImport.update({
            id: '/_protected',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/_auth',getParentRoute: () => rootRouteImport
          })
const PublicIndexRoute = PublicIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PublicRoute
          })
const ProtectedExampleProtectedRouteRoute = ProtectedExampleProtectedRouteRouteImport.update({
            id: '/example-protected-route',path: '/example-protected-route',getParentRoute: () => ProtectedRoute
          })
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          })
const AuthSignOutRoute = AuthSignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => AuthRoute
          })
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          })
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => AuthRoute
          })
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => AuthRoute
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/callback',path: '/callback',getParentRoute: () => AuthRoute
          })
const PublicAppIndexRoute = PublicAppIndexRouteImport.update({
            id: '/app/',path: '/app/',getParentRoute: () => PublicRoute
          })
const PublicAppHelpIndexRoute = PublicAppHelpIndexRouteImport.update({
            id: '/app/help/',path: '/app/help/',getParentRoute: () => PublicRoute
          })
const PublicAppHelpWindowsPhoneLinkRoute = PublicAppHelpWindowsPhoneLinkRouteImport.update({
            id: '/app/help/windows-phone-link',path: '/app/help/windows-phone-link',getParentRoute: () => PublicRoute
          })
const PublicAppHelpPrivacySecurityRoute = PublicAppHelpPrivacySecurityRouteImport.update({
            id: '/app/help/privacy-security',path: '/app/help/privacy-security',getParentRoute: () => PublicRoute
          })
const PublicAppHelpImportIphoneRoute = PublicAppHelpImportIphoneRouteImport.update({
            id: '/app/help/import-iphone',path: '/app/help/import-iphone',getParentRoute: () => PublicRoute
          })
const PublicAppHelpImportIpadRoute = PublicAppHelpImportIpadRouteImport.update({
            id: '/app/help/import-ipad',path: '/app/help/import-ipad',getParentRoute: () => PublicRoute
          })
const PublicAppHelpImportAndroidRoute = PublicAppHelpImportAndroidRouteImport.update({
            id: '/app/help/import-android',path: '/app/help/import-android',getParentRoute: () => PublicRoute
          })
const PublicAppHelpFaqRoute = PublicAppHelpFaqRouteImport.update({
            id: '/app/help/faq',path: '/app/help/faq',getParentRoute: () => PublicRoute
          })





const AuthRouteChildren = {
  AuthCallbackRoute: AuthCallbackRoute,AuthForgotPasswordRoute: AuthForgotPasswordRoute,AuthResetPasswordRoute: AuthResetPasswordRoute,AuthSignInRoute: AuthSignInRoute,AuthSignOutRoute: AuthSignOutRoute,AuthSignUpRoute: AuthSignUpRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)




const ProtectedRouteChildren = {
  ProtectedExampleProtectedRouteRoute: ProtectedExampleProtectedRouteRoute
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(ProtectedRouteChildren)




const PublicRouteChildren = {
  PublicIndexRoute: PublicIndexRoute,PublicAppIndexRoute: PublicAppIndexRoute,PublicAppHelpFaqRoute: PublicAppHelpFaqRoute,PublicAppHelpImportAndroidRoute: PublicAppHelpImportAndroidRoute,PublicAppHelpImportIpadRoute: PublicAppHelpImportIpadRoute,PublicAppHelpImportIphoneRoute: PublicAppHelpImportIphoneRoute,PublicAppHelpPrivacySecurityRoute: PublicAppHelpPrivacySecurityRoute,PublicAppHelpWindowsPhoneLinkRoute: PublicAppHelpWindowsPhoneLinkRoute,PublicAppHelpIndexRoute: PublicAppHelpIndexRoute
}

const PublicRouteWithChildren = PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,ProtectedRoute: ProtectedRouteWithChildren,PublicRoute: PublicRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)